import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { ColSpanEnum, FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { TimeInput } from '../../datetime/TimeInput';
import { DATA_FORM_INPUT } from '../../common/data';

export type TimeProps = VFFieldProps<React.ComponentProps<typeof TimeInput>> & {
  fullWidth?: boolean;
};
export const Time = React.forwardRef<HTMLInputElement, TimeProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      onChange: customOnChange,
      required,
      disabled,
      readOnly,
      fullWidth = false,
      dataTest,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        colSpan={fullWidth ? undefined : ColSpanEnum.Two}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (value?: string) => {
                const realValue = value || '';
                const rv = { target: { name, value: realValue } };
                customOnChange
                  ? customOnChange(realValue as any)
                  : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            return (
              <TimeInput
                {...DATA_FORM_INPUT(name)}
                fullWidth={fullWidth}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
